// TODO: Normalize ALL Options in the project to (Label and Value) OR (Title and Value) format

// ****************************** YES/ NO ******************************//
export enum YesNo {
  YES = 'S',
  NO = 'N',
}

export enum YesNoNull {
  NULL = 'null',
  TRUE = 'true',
  FALSE = 'false',
}

export const TypesValidations = {
  NO: YesNo.NO,
  NOT_APPLICABLE: 'X',
  YES: YesNo.YES,
} as const

export type CustomBoolean = YesNo.YES | YesNo.NO

export enum YesNoNotApplicable {
  YES = 'Sim',
  NO = 'Não',
  YES_UPPERCASE = 'SIM',
  NO_UPPERCASE = 'NÃO',
  NotApplicable = 'N/A',
}

export const yesNoOptions = [
  { title: YesNoNotApplicable.YES, value: YesNo.YES },
  { title: YesNoNotApplicable.NO, value: YesNo.NO },
]

export type ValidationOptions = (typeof TypesValidations)[keyof typeof TypesValidations]

//****************************** COMPANY ******************************//
export enum Company {
  ALPA = 'ALPA',
}

type CompanyType = {
  title: string
  value: Company
}

// TODO: Remove this when the API is ready
export const companies = {
  ALPA: { title: 'ALPA - Alpargatas S/A', value: Company.ALPA },
}

export const companyOptions: CompanyType[] = [companies.ALPA]

//****************************** ORGANIZATION ******************************//
export enum Organization {
  ALHV = 'ALHV',
  ALOM = 'ALOM',
}

type OrganizationOption = {
  title: string
  value: Organization
}

export const organizationOptions: OrganizationOption[] = [
  { title: 'ALHV - Havaianas', value: Organization.ALHV },
  { title: Organization.ALOM, value: Organization.ALOM },
]

//****************************** ORDER / OV ******************************//
export enum OVOrder {
  ORDER = 'ORDER',
  OV = 'OV',
}

//****************************** OV TYPES ******************************//
export enum OVTypes {
  YPEM = 'YPEM',
  YRBA = 'YRBA',
  YCPM = 'YCPM',
  YTRA = 'YTRA',
  YHFQ = 'YHFQ',
  YFRQ = 'YFRQ',
  YEXR = 'YEXR',
  YPOP = 'YPOP',
  YASC = 'YASC',
}

// TODO: Remove this when the API is ready
type OvType = {
  title: OVTypes
  value: OVTypes
}

// TODO: Remove this when the API is ready
export const defaultOvTypeOptions: OvType[] = [
  { title: OVTypes.YPEM, value: OVTypes.YPEM },
  { title: OVTypes.YCPM, value: OVTypes.YCPM },
  { title: OVTypes.YTRA, value: OVTypes.YTRA },
  { title: OVTypes.YHFQ, value: OVTypes.YHFQ },
  { title: OVTypes.YFRQ, value: OVTypes.YFRQ },
  { title: OVTypes.YEXR, value: OVTypes.YEXR },
  { title: OVTypes.YPOP, value: OVTypes.YPOP },
  { title: OVTypes.YASC, value: OVTypes.YASC },
]

//****************************** CHANNELS (MARKETS) ******************************//
export enum Channels {
  MI = 'MI',
  OP = 'OP',
  ME = 'ME',
}

type ChannelOption = {
  title: string
  value: Channels
}

export const channelOptions: ChannelOption[] = [
  {
    title: 'MI - Mercado Interno',
    value: Channels.MI,
  },
  {
    title: 'OP - Outras Operações',
    value: Channels.OP,
  },
  {
    title: 'ME - Mercado Externo',
    value: Channels.ME,
  },
]

//****************************** OFFICES ******************************//
export enum Offices {
  AC60 = 'AC60',
  AESP = 'AESP',
  AH01 = 'AH01',
  AHVA = 'AHVA',
  ALE1 = 'ALE1',
  ALE2 = 'ALE2',
  ALEH = 'ALEH',
  ASMD = 'ASMD',
  ALOS = 'ALOS',
  LTMH = 'LTMH',
}

type OfficesOption = {
  label: Offices
  value: Offices
  market?: string
}

export const officeByMarkets = {
  ME: [Offices.ALE1, Offices.ALE2, Offices.ALEH, Offices.LTMH],
  MI: [Offices.AC60, Offices.AESP, Offices.AHVA, Offices.ASMD],
  OP: [Offices.AH01, Offices.ALOS],
}

export const defaultOfficeOptions: OfficesOption[] = [
  { label: Offices.AC60, market: 'MI', value: Offices.AC60 },
  { label: Offices.AESP, market: 'MI', value: Offices.AESP },
  { label: Offices.AHVA, market: 'MI', value: Offices.AHVA },
  { label: Offices.ASMD, market: 'MI', value: Offices.ASMD },
  { label: Offices.AH01, market: 'OP', value: Offices.AH01 },
  { label: Offices.ALOS, market: 'OP', value: Offices.ALOS },
  { label: Offices.ALE1, market: 'ME', value: Offices.ALE1 },
  { label: Offices.ALE2, market: 'ME', value: Offices.ALE2 },
  { label: Offices.ALEH, market: 'ME', value: Offices.ALEH },
  { label: Offices.LTMH, market: 'ME', value: Offices.LTMH },
]

//****************************** CENTERS / FACTORIES ******************************//
export enum CentersFactories {
  A022 = 'A022',
  A026 = 'A026',
  A029 = 'A029',
  A055 = 'A055',
  A133 = 'A133',
  A297 = 'A297',
}

type CentersFactoriesOption = {
  title: CentersFactories
  value: CentersFactories
}

export const defaultFactoryOptions: CentersFactoriesOption[] = [
  { title: CentersFactories.A022, value: CentersFactories.A022 },
  { title: CentersFactories.A026, value: CentersFactories.A026 },
  { title: CentersFactories.A055, value: CentersFactories.A055 },
  { title: CentersFactories.A133, value: CentersFactories.A133 },
  { title: CentersFactories.A297, value: CentersFactories.A297 },
]

export const allFactoriesFilter = [
  { title: CentersFactories.A029, value: CentersFactories.A029 },
  ...defaultFactoryOptions,
].sort((a, b) => a.title.localeCompare(b.title))

export const availableCentersFactoriesFilter = [
  { title: 'Todos', value: 'todos' },
  ...defaultFactoryOptions,
]

export const availableCentersFactories = Object.values(CentersFactories)

//****************************** SECTORS ******************************//
export enum Sectors {
  AC = 'AC',
  AV = 'AV',
  OM = 'OM',
}

type SectorOption = {
  title: string
  value: Sectors
}

export const sectorOptions: SectorOption[] = [
  {
    title: 'AC - Calçados',
    value: Sectors.AC,
  },
  {
    title: 'AV - Acessórios e Vestuário',
    value: Sectors.AV,
  },
]

export const allSectorOptions = [...sectorOptions, { title: 'OM - Omni', value: Sectors.OM }]

//****************************** UNFOLD ******************************//
export enum Unfold {
  FABRICA = 'Fábrica',
  MATERIAL = 'Material',
}

type UnfoldOption = {
  title: Unfold
  value: (typeof TypesValidations)[keyof typeof TypesValidations]
}

export const unfoldOptions: UnfoldOption[] = [
  {
    title: Unfold.FABRICA,
    value: TypesValidations.NO,
  },
  {
    title: Unfold.MATERIAL,
    value: TypesValidations.YES,
  },
]

//****************************** MATERIAL TYPE ******************************//
export enum MaterialType {
  PADRAO = 'Padrão',
  MTO = 'MTO',
}

export enum TypeRuleExceptionStock {
  COR = 'C',
  CONTRAESTOQUE = 'F',
  MATERIAL = 'M',
  SKU = 'S',
}

type MaterialTypeOption = {
  title: MaterialType
  value: (typeof TypesValidations)[keyof typeof TypesValidations]
}

export const materialTypeOptions: MaterialTypeOption[] = [
  {
    title: MaterialType.PADRAO,
    value: TypesValidations.NO,
  },
  {
    title: MaterialType.MTO,
    value: TypesValidations.YES,
  },
]

//****************************** ORDER ORIGIN ******************************//
export enum OriginOrder {
  B2B = 'B', // Portal B2B
  HAVA = 'H', // Hava Conecta
  EDI = 'E', // EDI
}

//************************* STATUS ORDER HAVA *************************//
export enum StatusHAVA {
  Opened = 'A', // Aberto
  Finished = 'C', // Concluído
}

//************************* STATUS ORDER/OV EDI *************************//
// TODO: Get real status when backend is ready
export enum StatusEDI {
  Pending = 'P',
  Success = 'S',
  Error = 'E',
}

//****************************** PAYMENT TERMS ******************************//
// NOTE: This codes are from SAP. Any change in the codes in SAP must be updated here.
export enum PaymentTerms {
  AV01 = 'AV01',
}

//****************************** CRITICISM TYPE (STATUS) ******************************//
export enum CriticismType {
  QUOTA = 'COTA',
  STOCK = 'ESTOQUE',
  QUOTA_STOCK = 'COTA/ESTOQUE',
}

type CriticismTypeOption = {
  label: CriticismType
  value: CriticismType
}

export const criticismTypeOptions: CriticismTypeOption[] = [
  { label: CriticismType.QUOTA, value: CriticismType.QUOTA },
  { label: CriticismType.STOCK, value: CriticismType.STOCK },
  { label: CriticismType.QUOTA_STOCK, value: CriticismType.QUOTA_STOCK },
]

//************************* QUOTA LEVELS *************************//
export enum QuotaLevel {
  Zone = 'ZON',
  Regional = 'GRV',
  National = 'GNV',
  NotApplicable = 'N/A',
}

export const ShareLevel = {
  BMU: 'BMU',
  National: 'GNV',
  Regional: 'GRV',
  Zone: 'ZON',
}

//****************************** ND STATUS TYPE ******************************//
export type StatusNdType = 'pending' | 'justified' | 'approved'

//****************************** PRODUCTION TYPE ******************************//
export enum ProductionType {
  OUT_OF_LINE = 'FORA DE LINHA',
  IN_LINE = 'EM LINHA',
}

type ProductionTypeOption = {
  title: ProductionType
  value: (typeof TypesValidations)[keyof typeof TypesValidations]
}

export const productionTypeOptions: ProductionTypeOption[] = [
  { title: ProductionType.OUT_OF_LINE, value: TypesValidations.YES },
  { title: ProductionType.IN_LINE, value: TypesValidations.NO },
]

//************************* ORDER BLOCKERS *************************//
export enum OrderBlockers {
  ZONE = 'ZONA',
  GRV = 'GRV',
  GNV = 'GNV',
}

//****************************** CUSTOMER TYPE ******************************//
export enum CustomerType {
  PJ = 'J', // Pessoa Jurídica
  PF = 'F', // Pessoa Física
}

type CustomerTypeOption = {
  title: string
  value: CustomerType
}

export const customerTypeOptions: CustomerTypeOption[] = [
  { title: 'Pessoa Jurídica', value: CustomerType.PJ },
  { title: 'Pessoa Física', value: CustomerType.PF },
]

//****************************** ORDER MATERIAL LINE ******************************//
type MaterialLineOption = {
  title: string
  value: ValidationOptions
}

export const materialLineOptions: MaterialLineOption[] = [
  { title: 'Em linha', value: TypesValidations.NO },
  { title: 'Fora de linha', value: TypesValidations.YES },
]

//****************************** SAMPLE ORDER - YPOP ******************************//

export enum YpopCategory {
  YPOP = 'YPOP',
  YMKT = 'YMKT',
}

type YpopCategoryOption = {
  title: YpopCategory
  value: YpopCategory
}

export const ypopCategories: YpopCategoryOption[] = [
  { title: YpopCategory.YPOP, value: YpopCategory.YPOP },
  { title: YpopCategory.YMKT, value: YpopCategory.YMKT },
]

export enum SampleOrderCostElement {
  COST = 'costCenter',
  PEP = 'pepElement',
}

type SampleOrderCostElementOption = {
  title: string
  value: SampleOrderCostElement
}

export const sampleOrderCostElementOptions: SampleOrderCostElementOption[] = [
  { title: 'Centro de custo', value: SampleOrderCostElement.COST },
  { title: 'Elemento PEP', value: SampleOrderCostElement.PEP },
]

export const monthOptions = [
  { title: 'common.months.january', value: '01' },
  { title: 'common.months.february', value: '02' },
  { title: 'common.months.march', value: '03' },
  { title: 'common.months.april', value: '04' },
  { title: 'common.months.may', value: '05' },
  { title: 'common.months.june', value: '06' },
  { title: 'common.months.july', value: '07' },
  { title: 'common.months.august', value: '08' },
  { title: 'common.months.september', value: '09' },
  { title: 'common.months.october', value: '10' },
  { title: 'common.months.november', value: '11' },
  { title: 'common.months.december', value: '12' },
]

//****************************** FAIR SHARE ******************************//

export enum FairShareLevel {
  BMU = 'BMU',
  GNV = 'GNV',
  GRV = 'GRV',
  ZON = 'ZON',
}

export enum FairShareLayer {
  OFFICE = 'office',
  TEAM = 'team',
  REGION = 'region',
}

type FairShareLevelOption = {
  title: string
  value: FairShareLevel
  layers: FairShareLayer[]
}

export const fairShareLevelOptions: FairShareLevelOption[] = [
  {
    layers: [FairShareLayer.OFFICE],
    title: 'common.bmu',
    value: FairShareLevel.BMU,
  },
  {
    layers: [FairShareLayer.OFFICE, FairShareLayer.TEAM],
    title: 'common.gnv',
    value: FairShareLevel.GNV,
  },
  {
    layers: [FairShareLayer.OFFICE, FairShareLayer.TEAM, FairShareLayer.REGION],
    title: 'common.grv',
    value: FairShareLevel.GRV,
  },
  {
    layers: [FairShareLayer.TEAM, FairShareLayer.REGION],
    title: 'common.zone',
    value: FairShareLevel.ZON,
  },
]

//****************************** EDI ******************************//
// NOTE: Values match the API's Status field/query param (e.g. Status=FALHA&Status=PROCESSADO)
export enum EdiStatus {
  FAIL = 'FALHA',
  PROCESSED = 'PROCESSADO',
  PROCESSED_WITH_ISSUE = 'PROCESSADO_COM_CRITICA',
  PROCESSING = 'EM_PROCESSAMENTO',
  REPROCESSING_REQUESTED = 'REPROCESSAMENTO_SOLICITADO',
}

export enum EdiError {
  CUSTOMER = 'CUSTOMER',
  MATERIAL = 'MATERIAL',
  MULTIPLICITY = 'MULTIPLICITY',
}

export type EdiStatusOption = {
  title: string
  value: EdiStatus
}

// NOTE: W.I.P
export type EdiRequest = {
  id: string // Codigo
  status: EdiStatus // Status
  customerOrder: string // NumeroPedidoCliente
  orderNumber?: string | null // nr_pedi_rasc
  legalName: string // RazaoSocial
  sapCode: string // CodigoSap
  requestedAt: string // SolicitadoEm
  formattedDate: string
  formattedTime: string
  errors: EdiError[] | null
  logs?: string[] | null
  expanded?: boolean
  checked?: boolean
}

// NOTE: W.I.P
export const EdiStatusOptions: Record<EdiStatus, string> = {
  [EdiStatus.FAIL]: 'Falha',
  [EdiStatus.PROCESSED]: 'Processado',
  [EdiStatus.PROCESSED_WITH_ISSUE]: 'Processado c/ críticas',
  [EdiStatus.PROCESSING]: 'Em processamento',
  [EdiStatus.REPROCESSING_REQUESTED]: 'Reprocessamento solicitado',
}

// NOTE: W.I.P
export const EdiErrorOptions: Record<EdiError, string> = {
  [EdiError.CUSTOMER]: 'Cliente',
  [EdiError.MATERIAL]: 'Material',
  [EdiError.MULTIPLICITY]: 'Multiplicidade',
}

export enum FairShareFileTemplateUrl {
  BMU = 'upload_bmu.xlsx',
  OFFICE = 'upload_gnv_grv_zon.xlsx',
  META = 'upload_meta.xlsx',
}
